<template>
	<div class="notify-me-section">
		<div class="notify-me">
			{{ $t('settings_notifications_section_defaults') }}
		</div>

		<div class="options-wrapper">
			<RadioGroup :options="options" v-model="selected" @change="onChange">
				<template #selector="{ data }">
					<Spinner v-if="data.value === savingValue" class="loading-spinner" />
					<CheckIcon v-else-if="data.value === selected" type="regular" />
					<CircleIcon v-else />
				</template>
			</RadioGroup>
		</div>
	</div>
</template>

<script>
import store, { getChat, getMyMembershipForBubble, getMyUser } from '@/store'
import { RadioGroup, Spinner } from '@/components/common'
import { CheckIcon, CircleIcon } from '@/icons'

export default {
	components: { RadioGroup, Spinner, CheckIcon, CircleIcon },
	props: {
		group: {
			type: Number,
			required: false,
		},
		isdm: {
			type: Boolean,
			default: null,
		},
	},

	data() {
		return {
			store,
			processing: false,
			selected: this.getMyNotificationPreference(),
			savingValue: null,
			isSuperGroup: false,
		}
	},

	mounted() {
		this.$onEventBus('membership-update|chat-update', () => {
			this.selected = this.getMyNotificationPreference()
		})
	},

	computed: {
		options() {
			return [
				{
					value: 'ALL',
					label: this.$t('settings_notification_prefs_all_messages'),
				},
				!this.isdm && {
					value: 'MENTIONS',
					label: this.$t('settings_notification_prefs_only_mentions'),
				},
				{
					value: 'NONE',
					label: this.$t('settings_notification_prefs_nothing'),
				},
			].filter((x) => x)
		},
	},

	methods: {
		async onChange(value) {
			if (this.getMyNotificationPreference() === value) return

			this.savingValue = value
			let payload = { notificationpreference: value }
			if (this.group) {
				payload.bubble_id = this.group
			}

			await this.store.setNotificationPreference(this.group, payload)

			this.savingValue = null
		},

		getMyNotificationPreference() {
			const chat = getChat(this.group)
			const membership = getMyMembershipForBubble(this.group)
			const userPreference = getMyUser()?.notificationpreference

			// Get membership preference, defaulting to null if no membership exists
			let preference = membership?.notificationpreference

			// For supergroups, default to MENTIONS if inheriting
			if (chat?.is_supergroup && preference === 'DEFAULT_INHERIT') {
				return 'MENTIONS'
			}

			// If no preference or inheriting, fallback to user's default preference
			return preference && preference !== 'DEFAULT_INHERIT'
				? preference
				: userPreference ?? null
		},
	},
}
</script>

<style lang="scss" scoped>
.notify-me-section {
	font-family: Avenir-Medium;
	font-size: 15px;
	margin-top: 24px;
}

.notify-me {
	font-family: Avenir-Heavy;
	font-size: 18px;
	margin-bottom: 14px;
}

.loading-spinner {
	font-size: 26px;
	margin-right: -5px;
}
</style>
